import { render, staticRenderFns } from "./ControlSwitch.vue?vue&type=template&id=1efb1554&"
import script from "./ControlSwitch.vue?vue&type=script&lang=js&"
export * from "./ControlSwitch.vue?vue&type=script&lang=js&"
import style0 from "./ControlSwitch.vue?vue&type=style&index=0&id=1efb1554&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports